import { documentHasElements } from "modules/dom";

// Function to clean Zero Width No-Break Space (BOM) character
function cleanText(text: string): string {
    return text.replace(/\uFEFF/g, "");
}

documentHasElements(".js-legacy-block", (LagacyBlocks) => {
    LagacyBlocks.forEach((lagacyBlock) => {
        const scrollDetector = lagacyBlock.querySelector<HTMLElement>(".scroll-detector");
        const cardsHeader = lagacyBlock.querySelectorAll<HTMLHeadingElement>(".cards > div h3");
        const cardsParagraph = lagacyBlock.querySelectorAll<HTMLParagraphElement>(".cards > div p");

        // Clean BOM characters from all text content
        const allTextElements = lagacyBlock.querySelectorAll<HTMLElement>("h2, h3, p");
        allTextElements.forEach((element) => {
            if (element.textContent) {
                element.textContent = cleanText(element.textContent);
            }
        });

        const observer = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry: IntersectionObserverEntry) => {
                if (entry.isIntersecting) {
                    cardsHeader.forEach((h3: HTMLHeadingElement) => {
                        h3.classList.add("scrolled");
                    });

                    setTimeout(() => {
                        cardsParagraph.forEach((p: HTMLParagraphElement) => {
                            p.classList.add("scrolled");
                        });
                    }, 200);
                }
            });
        }, {
            rootMargin: "0px 0px 350px 0px",
        });

        if (scrollDetector) {
            observer.observe(scrollDetector);
        }

    });
});